import { Typography } from '@mui/material';
import { Row, Spacer } from '../../../components';

interface SvgBulletRowProps {
  art: React.ReactNode;
  text: string;
  boldPostText?: string;
}

const SvgBulletRow: React.FC<SvgBulletRowProps> = ({ art, text, boldPostText }) => {
  return (
    <Row style={{ alignItems: 'center' }}>
      {art}
      <Spacer width='xs' />
      <Typography sx={{ maxWidth: '80%' }} variant='body1' color='info.main'>
        {text}
        <strong>{boldPostText}</strong>
      </Typography>
    </Row>
  );
};

export default SvgBulletRow;
